/**Темы */
enum ThemeEnum {
  /**Светлая */
  Light = 'light',
  /**Темная */
  Dark = 'dark',
  /**Системная */
  System = 'system',
}

export { ThemeEnum }
